import SearchBox from "@/common/SearchBox";
import { useRouter } from "@tanstack/react-router";
import { useState } from "react";
import { useBusinessMypageContractList } from "~/services/business/myPage";

/** 탭 1: 체결완료된 계약 목록 (기존 화면 추출) */
export const ContractTabContracts = () => {
  const { history } = useRouter();
  const [searchKeyword, setSearchKeyword] = useState<string>("");
  const [currentSearchKeyword, setCurrentSearchKeyword] = useState<string>("");
  const PAGE_SIZE = 10;
  // 페이지 이동 UI 없이 "더보기"로 노출 건수를 늘린다 (page=1, size 만 키움)
  const [limit, setLimit] = useState<number>(PAGE_SIZE);

  const apiParams = {
    searchKeyword: currentSearchKeyword,
    page: 1,
    size: limit,
  };

  const { data: contractListData } = useBusinessMypageContractList(apiParams);

  const handleSearch = (keyword: string) => {
    setCurrentSearchKeyword(keyword);
    setLimit(PAGE_SIZE);
  };

  const total = contractListData?.data.totalElements ?? 0;
  const shown = contractListData?.data.content.length ?? 0;
  const hasMore = shown < total;

  return (
    <div>
      {/* 검색 + 카운트 — sticky 로 상단 고정 */}
      <div className="bg-[#F5F5F5] sticky top-0 z-10">
        <div className="mx-2">
          <div className="flex justify-end items-center px-2 py-3">
            <SearchBox
              searchText={searchKeyword}
              setSearchText={setSearchKeyword}
              onSearch={handleSearch}
              placeholder="반려동물 이름 또는 보호자 닉네임으로 검색"
            />
          </div>
        </div>
      </div>

      <div className="flex gap-2 items-center pl-1 mx-4 mb-2">
        <div className="text-[14px] font-semibold">
          총 {contractListData?.data.totalElements || 0}건
        </div>
        <div className="text-[13px] text-[#999999]">|</div>
        <div className="text-[13px] text-[#999999]">
          완료된 계약 건수입니다.
        </div>
      </div>

      <div className="grid grid-cols-10 gap-2 items-center mx-4 mb-2">
        <div className="col-span-2 text-[14px] text-[#666666] text-center">
          고객명
        </div>
        <div className="col-span-2 text-[13px] text-[#666666] text-center">
          반려동물
        </div>
        <div className="col-span-3 text-[14px] text-[#666666] text-center">
          계약일
        </div>
        <div className="col-span-2 text-[13px] text-[#666666] text-center">
          종료일
        </div>
      </div>

      {contractListData?.data.content.map((contract) => {
        const isRemote = contract.sourceType === "REMOTE";
        const rowKey = isRemote
          ? `remote-${contract.requestSeq}`
          : `onsite-${contract.histContrSeq}`;
        const goDetail = () =>
          history.push(
            isRemote
              ? `/business/layout/contract-request-detail?requestSeq=${contract.requestSeq}`
              : `/business/layout/user-contract-detail?histContrSeq=${contract.histContrSeq}`,
          );
        return (
          <div
            className="grid grid-cols-10 gap-2 items-center mx-4 mb-2 bg-white rounded-lg border border-[#e9e9e9] h-[50px] cursor-pointer"
            key={rowKey}
            onClick={goDetail}
          >
            <div className="col-span-2 text-[14px] text-[#666666] text-center">
              {contract.userName}
            </div>
            <div className="col-span-2 text-[13px] text-[#666666] text-left overflow-hidden text-ellipsis whitespace-nowrap flex items-center gap-1">
              <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                {contract.petName}
              </span>
              {isRemote && (
                <span className="shrink-0 text-[9px] bg-[#F5F3FF] text-[#7D6DFF] font-bold rounded px-1 py-0.5">
                  앱
                </span>
              )}
            </div>
            <div className="col-span-3 text-[14px] text-[#666666] text-center">
              {contract.startContractDate}
            </div>
            <div className="col-span-3 text-[13px] text-[#666666] text-center">
              {contract.endContractDate}
            </div>
          </div>
        );
      })}

      {hasMore && (
        <div className="flex justify-center px-4 my-3">
          <button
            type="button"
            onClick={() => setLimit((l) => l + PAGE_SIZE)}
            className="w-full max-w-[240px] rounded-full border border-[#e9e9e9] bg-white py-2.5 text-[13px] font-semibold text-[#666] active:bg-gray-50"
          >
            더보기 ({shown}/{total})
          </button>
        </div>
      )}
    </div>
  );
};
